import axiosPost from "../axiosPost";

export const SBMTipoDeDocumentoGet = async (
    { tipoDeDocumentoId = null } = {},
    credentials
) => {
    const body = {
        service: "SBMTipoDeDocumentoGet",
        params: { 
            sbmTipoDeDocumentoId: tipoDeDocumentoId 
        },
    };

    return await axiosPost(body, credentials);
};
